export default "static/src/Videos/AZIENDE.mp4";